import React, { createContext, useContext, useState, useEffect } from 'react';

const LayoutContext = createContext();

// Detect if device is mobile based on screen width
const isMobileDevice = () => {
  return window.innerWidth <= 768;
};

export function LayoutProvider({ children }) {
  // Always default to desktop mode
  const [mobileLayout, setMobileLayout] = useState(false);

  const toggleLayout = () => {
    setMobileLayout(prev => !prev);
  };

  // Add/remove class on body for CSS targeting
  useEffect(() => {
    if (mobileLayout) {
      document.body.classList.add('mobile-layout');
    } else {
      document.body.classList.remove('mobile-layout');
    }
  }, [mobileLayout]);

  return (
    <LayoutContext.Provider value={{ mobileLayout, toggleLayout }}>
      {children}
    </LayoutContext.Provider>
  );
}

export function useLayout() {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
}
